export const rightColumnItemStyleProps = {
    paddingY: 8,
    paddingX: 4,
    borderBottomWidth: '1px',
    borderColor: 'gray.100',
    alignItems: {base: 'center', tablet: 'flex-start'},
    flexDirection: 'column',
    _last: {
        borderBottomWidth: {base: '1px', tablet: 0},
        borderBottomRadius: {base: 'none', tablet: 'lg'},
    },
    _first: {
        borderTopRadius: {base: 'none', tablet: 'lg'},
    },
};

export const leftColumnItemStyleProps = {
    marginBottom: {base: 8, tablet: 10, desktop: 14},
    paddingBottom: {base: 8, tablet: 0},
    paddingX: {base: 4, desktop: 0},
    borderBottomWidth: {base: '1px', tablet: 0},
    borderColor: 'gray.100',
    _last: {
        marginBottom: 0,
    },
};
